import type { ReactElement } from 'react'

import { Box } from '@mui/material'

import { FullScreenContainer } from './components/FullScreenContainer'
import { MainSectionContainer } from './components/MainSectionContainer'

interface Props {
  children: ReactElement
  header: ReactElement
}

const contentContainerSx = {
  maxWidth: '450px',
}

export function ErrorPageLayout(props: Props) {
  const { children, header } = props

  return (
    <FullScreenContainer>
      <MainSectionContainer>
        <>
          {header}

          <Box sx={contentContainerSx}>{children}</Box>
        </>
      </MainSectionContainer>
    </FullScreenContainer>
  )
}
